import { render, staticRenderFns } from "./InventoryRequestTemplate.vue?vue&type=template&id=322d1e90&"
import script from "./InventoryRequestTemplate.vue?vue&type=script&lang=js&"
export * from "./InventoryRequestTemplate.vue?vue&type=script&lang=js&"
import style0 from "./InventoryRequestTemplate.vue?vue&type=style&index=0&id=322d1e90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports